import {
    getAvailableDateRangesAPI,
    getAnalyticsDataAPI,
} from "./api"

export function getAvailableDateRanges(store) {
    return new Promise((resolve, reject) => {
        getAvailableDateRangesAPI(store).then((res) => resolve(res)).catch(err => reject(err))
    })
}

export function getAnalyticsData(filename) {
    return new Promise((resolve, reject) => {
        getAnalyticsDataAPI(filename).then((res) => resolve(res)).catch(err => reject(err))
    })
}
